var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointmentClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9661_153175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9914 2.50391C8.09141 2.50391 2.50391 8.10391 2.50391 15.0039C2.50391 21.9039 8.09141 27.5039 14.9914 27.5039C21.9039 27.5039 27.5039 21.9039 27.5039 15.0039C27.5039 8.10391 21.9039 2.50391 14.9914 2.50391ZM15.0039 25.0039C9.47891 25.0039 5.00391 20.5289 5.00391 15.0039C5.00391 9.47891 9.47891 5.00391 15.0039 5.00391C20.5289 5.00391 25.0039 9.47891 25.0039 15.0039C25.0039 20.5289 20.5289 25.0039 15.0039 25.0039Z",
    fill: "#1F3864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6289 8.74609H13.7539V16.2461L20.3164 20.1836L21.2539 18.6461L15.6289 15.3086V8.74609Z",
    fill: "#1F3864"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9661_153175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentClock);
export default __webpack_public_path__ + "static/media/appointment_clock.7ef585b30e0323b7eeb5576b90e1c1d6.svg";
export { ForwardRef as ReactComponent };